<template>
    <div class="mt-8">
      <!-- Discovery question -->
      <div v-if="discoveryQuestion" class="flex flex-col items-center mx-4">
        <SidebarTitle icon="Edit3Icon" title="question">
          <span class="text-dark flex items-center" :class="{...actionElementCss, 'opacity-0': !emptyGetInspiredDescription}" @click.stop="changeQuestion">
              <feather-icon icon="RefreshCwIcon" class="ml-1 mb-0 w-4 cursor-pointer font-bold "/>
          </span>
        </SidebarTitle>

        <div class="text-center">
          <div class="text-black justify-center flex text-2xl">
            <span>
              {{storyLocal.getInspiredQuestion}}
            </span>
          </div>
        </div>

        <SidebarTitle icon="FeatherIcon" title="journal entry" class="mt-2"/>
          <div class="text-center w-10/12 story-text-area">
            <vs-textarea
              color="dark"
              label=""
              v-model="storyLocal.getInspiredDescription"
              name="getInspiredDescription"
              class="w-full"
              autocomplete="off"
              @keyup.enter.native.stop=""
              height="300px"
            />
          </div>
      </div>

      <!-- Free write -->
      <div v-if="freeWrite">
        <SidebarTitle icon="FeatherIcon" title="journal entry"/>
        <div class="text-center flex justify-center">
          <div class="text-center w-10/12 story-text-area">
            <vs-textarea
              color="dark"
              label="I am feeling..."
              v-model="storyLocal.freeWriteDescription"
              name="freeWriteDescription"
              class="w-full"
              autocomplete="off"
              @keyup.enter.native.stop=""
              height="300px"
            />

          </div>
        </div>
      </div>


       <div v-if="showSentiment" class="mt-2">
         <SidebarTitle icon="BookmarkIcon" title="type of entry"/>
          <div class="flex justify-center">

           <div class="mt-2">
              <vs-radio vs-name="good" color="success" class="mr-3" v-model="storyLocal.sentiment" vs-value="good">good</vs-radio>
              <vs-radio vs-name="good" color="dark" class="mr-3" v-model="storyLocal.sentiment" vs-value="neutral">neutral</vs-radio>
              <vs-radio vs-name="not_so_good" color="danger" class="mr-3" v-model="storyLocal.sentiment"
   vs-value="not_so_good">not so good</vs-radio>
           </div>
         </div>
      </div>

      <!-- Mood tracker -->
      <div v-if="moodTracker">
        <div class="flex flex-col items-center">
          <div class="text-4xl text-black">I {{feelText}} <span class="font-bold">{{moodText}}</span></div>
          <div class="w-3/4">
            <vs-slider
              v-model="storyLocal.mood"
              color="black"
              :step="1"
              max="10"
              :height="25"
              class="m-1"
              />
            <GoodNotSoGood/>
          </div>
        </div>
      </div>

      <div v-if="showAreas" class="mt-8">
          <SidebarTitle class="mb-2"  icon="HexagonIcon" title="related areas"/>
        <div class="flex mb-8 justify-evenly">
          <Checkbox class="p-0" initValue="health" title="health" icon="ActivityIcon" v-model="storyLocal.whyDoYouFeelThatWay" />
          <Checkbox class="p-0" initValue="play" title="play" icon="UsersIcon" v-model="storyLocal.whyDoYouFeelThatWay" />
          <Checkbox class="p-0" initValue="spirituality" title="spirituality" icon="SunriseIcon" v-model="storyLocal.whyDoYouFeelThatWay" />
          <Checkbox class="p-0" initValue="enviroment" title="enviroment" icon="ImageIcon" v-model="storyLocal.whyDoYouFeelThatWay" />
        </div>

        <div class="flex mb-8 justify-evenly">

          <Checkbox class="p-0" initValue="work" title="work" icon="BriefcaseIcon" v-model="storyLocal.whyDoYouFeelThatWay" />
          <Checkbox class="p-0" initValue="wealth" title="wealth" icon="DollarSignIcon" v-model="storyLocal.whyDoYouFeelThatWay" />
          <Checkbox class="p-0" initValue="growth" title="growth" icon="BookIcon" v-model="storyLocal.whyDoYouFeelThatWay" />

          <Checkbox class="p-0" initValue="relationships" title="relationships" icon="HeartIcon" v-model="storyLocal.whyDoYouFeelThatWay" />
        </div>
      </div>

      <!-- lifeBalance -->
      <div v-if="lifeBalance" class="flex-col flex items-center">

      <div class="w-5/6">
          <FirstChapterItem v-model="storyLocal.lifeBalance.work" icon="BriefcaseIcon" title="Work" class="m-3"/>
        </div>

        <div class="w-5/6">
          <FirstChapterItem v-model="storyLocal.lifeBalance.wealth" icon="DollarSignIcon" title="Wealth" class="m-3"/>
        </div>

        <div class="w-5/6">
          <FirstChapterItem v-model="storyLocal.lifeBalance.spirituality" icon="SunriseIcon" title="Spirituality" class="m-3"/>
        </div>
        <div class="w-5/6">
          <FirstChapterItem v-model="storyLocal.lifeBalance.health" icon="ActivityIcon" title="Health" class="m-3"/>
        </div>
        <div class="w-5/6">
          <FirstChapterItem v-model="storyLocal.lifeBalance.growth" icon="BookIcon" title="Growth" class="m-3"/>
        </div>
        <div class="w-5/6">
          <FirstChapterItem v-model="storyLocal.lifeBalance.relationships" icon="HeartIcon" title="Relationships" class="m-3"/>
        </div>

        <div class="w-5/6">
          <FirstChapterItem v-model="storyLocal.lifeBalance.play" icon="UsersIcon" title="Play" class="m-3"/>
        </div>
        <div class="w-5/6">
          <FirstChapterItem v-model="storyLocal.lifeBalance.environment" icon="ImageIcon" title="Environment" class="m-3"/>
        </div>

      </div>
    </div>
</template>
<script>
import _ from 'lodash'
// import trackAnalytics from '@/helpers/trackAnalytics'
import { midnight, formatyyymmdd, ensuredDateEqual } from '@/helpers/date'
import trackAnalytics from '@/helpers/trackAnalytics'
// import ColorPicker from '@/views/Self-Improvee/Generic/ColorPicker'
import GetInspiredQuestions from '@/models/GetInspiredQuestions'
import Checkbox from '../Onboarding/Wizard/Checkbox'
import FirstChapterItem from '../Journey/FirstChapterItem'
import Story from '@/models/Story'

export default {
  components: {
    Checkbox,
    FirstChapterItem
    // ColorPicker,
  },
  props: {
    editedEntity: {
      type: Object,
      required: false,
      default: () => {}
    },
  },
  data () {
    return {
      storyLocal: {},
    }
  },
  watch: {
    editedEntity: {
      immediate: true,
      async handler (editedEntity) {
        if (!editedEntity) return

        this.storyDefaults.getInspiredQuestion = this.getRandomQuestion()
        this.storyLocal = _.merge({}, this.storyDefaults, editedEntity)


        // if (!editedEntity) {
        //   this.deadlineRaw = null
        // }

        // if (this.storyLocal.deadline) {
        //   if (this.edit) {
        //     this.deadlineRaw = formatyyymmdd(this.storyLocal.deadline.toDate())
        //   } else {
        //     this.deadlineRaw = formatyyymmdd(this.storyLocal.deadline)
        //   }
        // }

        if (editedEntity) {
          await this.$validator.resume()
        } else {
          await this.$validator.pause()
        }
      }
    },
  },
  computed: {
    feelText () {
      return this.isToday ? "feel" : "felt"
    },
    isToday () {
      return ensuredDateEqual(this.storyLocal.deadline, this.$store.getters.today)
    },
    showAreas () {
      return !this.lifeBalance
    },
    storyEntity () {
      return new Story(this.storyLocal)
    },
    moodText () {
      return this.storyEntity.moodText()
    },
    mood () {
      return this.storyLocal.mood
    },
    showSentiment () {
      return this.freeWrite || this.discoveryQuestion
    },
    storyDefaults () {
      return {
        sentiment: 'neutral',
        deadline: midnight(),
        freeWriteDescription: '',
        getInspiredDescription: '',
        getInspiredQuestion: this.getRandomQuestion(),
        mood: 5,
        whyDoYouFeelThatWay: [],
        lifeBalance: {
          work: null,
          wealth: null,
          spirituality: null,
          health: null,
          growth: null,
          relationships: null,
          play: null,
          environment: null
        }
      }
    },
    emptyGetInspiredDescription () {
      return this.storyLocal.getInspiredDescription === ''
    },
    promptActive () {
      return !!this.editedEntity
    },
    edit () {
      return !!_.get(this.editedEntity, 'id')
    },
    create () {
      return !this.edit
    },
    freeWrite () {
      return this.storyLocal.storyType === 'freeWrite'
    },
    discoveryQuestion () {
      return this.storyLocal.storyType === 'discoveryQuestion'
    },
    moodTracker () {
      return this.storyLocal.storyType == 'moodTracker'
    },
    lifeBalance () {
      return this.storyLocal.storyType == 'lifeBalance'
    },
  },
  methods: {
    changeQuestion () {
      this.storyLocal.getInspiredQuestion = this.getRandomQuestion()

      console.log(this.storyLocal.getInspiredQuestion)
    },
    close () {
      // console.log('closing')
      // this.deadlineRaw = ''
      this.$emit('close')
      this.$router.push({ name: 'journey' }).catch(() => {})
    },
    getRandomQuestion () {
      return _.sample(GetInspiredQuestions)
    },
    save () {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return

        if (this.edit) {
          const { freeWriteDescription, sentiment, getInspiredDescription, mood, whyDoYouFeelThatWay, lifeBalance } = this.storyLocal
          this.$store.dispatch('UPDATE_STORY', { story: this.editedEntity, updateFields: { freeWriteDescription, sentiment, getInspiredDescription, mood, whyDoYouFeelThatWay, lifeBalance } })
          this.$store.dispatch('ADDITIONAL_USER_INFO', { storyEdited: true })
        } else {
          trackAnalytics(this, 'app_action', 'story', 'story_create', this.$store.getters.daysFromRegistration)
          this.$store.dispatch('ADDITIONAL_USER_INFO', { storyCreated: true })

          const done = {}
          done[this.storyLocal.storyType + "Created"] = true

          this.$store.dispatch('ADDITIONAL_USER_INFO', done)

          this.$store.dispatch('ADD_STORY', { story: this.storyLocal })
        }

        // trackAnalytics(this, 'app_action', this.edit ? 'update_goal' : 'add_goal', null, this.$store.getters.daysFromRegistration)
        this.close()
      })
    },
  },
  beforeDestroy () {
    this.$root.$off('storySidebarFooterSaveClicked')
  },
  mounted () {
    this.$root.$on('storySidebarFooterSaveClicked', () => {
      this.notifier.journalAdded(this.$store)
      this.save()
    })
  },
}
</script>

<style lang="scss">

.story-text-area {
  .vs-textarea {
    height: 275px;
    resize: none !important;
  }
}

</style>
